import { NPS_SESSION_CHANGED_EVENT } from "@/lib/nps/constants";

export const NPS_TIMER_STARTED_KEY = "playmath_nps_timer_started_at";
export const NPS_LAST_GAME_KEY = "playmath_nps_last_game";

export interface NpsLastGame {
  slug: string;
  id: string | null;
}

/** Last game played in this tab — used when submitting NPS after close. */
export function getNpsLastGame(): NpsLastGame | null {
  try {
    const raw = sessionStorage.getItem(NPS_LAST_GAME_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { slug?: string; id?: string | null };
    if (!parsed?.slug || typeof parsed.slug !== "string") return null;
    return { slug: parsed.slug, id: parsed.id ?? null };
  } catch {
    return null;
  }
}

/**
 * Call when a visitor opens a game. Starts the 15-minute dwell timer once per
 * tab session and stores game context for the post-close sticky NPS form.
 * First-visit day stamping is handled site-wide by `NpsVisitRecorder`.
 */
export function beginNpsGameSession(game: { slug: string; id?: string | null }): void {
  try {
    sessionStorage.setItem(
      NPS_LAST_GAME_KEY,
      JSON.stringify({ slug: game.slug, id: game.id ?? null })
    );
    if (!sessionStorage.getItem(NPS_TIMER_STARTED_KEY)) {
      sessionStorage.setItem(NPS_TIMER_STARTED_KEY, String(Date.now()));
    }
  } catch (error) {
    console.error("Error beginning NPS game session", { gameSlug: game.slug, error });
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(NPS_SESSION_CHANGED_EVENT));
  }
}

export function readNpsTimerStartedAt(): number | null {
  try {
    const raw = sessionStorage.getItem(NPS_TIMER_STARTED_KEY);
    if (!raw) return null;
    const startedAt = Number(raw);
    return Number.isFinite(startedAt) ? startedAt : null;
  } catch {
    return null;
  }
}
